export * from './heading-component-config.interface';
export * from './heading-type.enum';
